import { render, staticRenderFns } from "./CustomPerDiemModal.vue?vue&type=template&id=72bb3a62&scoped=true&"
import script from "./CustomPerDiemModal.vue?vue&type=script&lang=js&"
export * from "./CustomPerDiemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bb3a62",
  null
  
)

export default component.exports